import { IS_STNET } from '@utils/Constants'
import { EmailType, UserData } from 'src/models/User'
import { AuthorizationUserType } from '../authorizationUserType'
import { get, post, put } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getUser
 */

type UserResponseData = {
  user: UserData
}

export const getUser = async (userId?: number) => {
  const data = await get<UserResponseData>('/v1/auth/info', { userId, isSTNet: IS_STNET })
  return data.user
}

//////////////////////////////////////////////////////////////////////
// POST
//////////////////////////////////////////////////////////////////////

/**
 * confirmPassword
 */

export type ConfirmPasswordParams = {
  email: string
  code: string
  password: string
}

export const confirmPassword = async (params: ConfirmPasswordParams) => {
  await post('/v1/auth/confirmForgotPassword', params, false)
}

/**
 * getUserFromEmail
 */

export type GetUserFromEmailParams = {
  type: AuthorizationUserType
  email?: string
  loginCode?: string
  password: string
  userCode?: string
}

export const getUserFromEmail = async (params: GetUserFromEmailParams) => {
  const data = await post<UserResponseData>('/v1/auth/login', { ...params, isSTNet: IS_STNET }, false)
  return data.user
}

/**
 * sendResetPasswordEmail
 */

export type SendResetPasswordEmailParams = {
  email: string
}

export const sendResetPasswordEmail = async (params: SendResetPasswordEmailParams) => {
  await post('/v1/auth/forgotPassword', params, false)
}

//////////////////////////////////////////////////////////////////////
// PUT
//////////////////////////////////////////////////////////////////////

/**
 * updateEmail
 */

export type UpdateEmailParams = {
  email: string
  emailType: EmailType
  consumptionAlertThreshold: number
  phoneNumber?: string
}

export const updateEmail = async (params: UpdateEmailParams) => {
  await put('/v1/auth/updateEmail', params)
}
